

<mat-card class="filter settingHeader">
    <div class="name">
        All Monotoring
    </div>
    <div class="quickAction">
        <mat-form-field class="example-form-field" appearence="fill" >
            <mat-label>Search Monotoring</mat-label>
            <input matInput type="text" >            
          </mat-form-field>
          <button mat-icon-button color="primary" (click)="showFilter()" > <mat-icon>filter_alt</mat-icon> </button>
        <div class="">
            
            <button mat-flat-button color="primary" (click)="openCaseDetail()" > Create Monitoring </button>
        </div>
    </div>
</mat-card>

<div class="searcholder">
   

    <div class="searchResult">

        <div class="allresult">

            <mat-card class="result">
                <div class="imghold">
                    <img src="https://neteera.com/og.jpg" alt="hospital" />
                </div>
                <div class="resultInfo">
                    <h3>Neterra</h3>
                    <p>18/63 Oxford Street Surry Hills, NSW 2010</p>
                    <p class="perinfo">
                        <span>
                            <mat-icon>phone</mat-icon>98758958798
                        </span>
                        <span>
                            <mat-icon>mail</mat-icon>standford@flowtrics.com
                        </span>
                        <span>
                            <mat-icon>location_on</mat-icon>1.5 KM
                        </span>
                    </p>
                    <div class="">
                        <button mat-stroked-button color="primary" (click)="sendRequest(facilityrequest)">Send Request</button>
                    </div>
                </div>
            </mat-card>

            <mat-card class="result">
                
                <div class="imghold">
                    <img src="https://media-exp3.licdn.com/dms/image/C560BAQGU-jec-2XRhQ/company-logo_200_200/0/1519898435545?e=2159024400&v=beta&t=dX-MHhUMbeE_zYhV9GNOwNa27D55IJAfuZGhtiX8l2g" alt="">
                </div>
                <div class="resultInfo">
                    <h3>Cardiomo</h3>
                    <p>18/63 Oxford Street Surry Hills, NSW 2010</p>
                    <p class="perinfo">
                        <span>
                            <mat-icon>phone</mat-icon>98758958798
                        </span>
                        <span>
                            <mat-icon>mail</mat-icon>standford@flowtrics.com
                        </span>
                        <span>
                            <mat-icon>location_on</mat-icon>1.5 KM
                        </span>
                    </p>
                    <div class="">
                        <button mat-stroked-button color="primary" (click)="sendRequest(facilityrequest)">Send Request</button>
                    </div>
                </div>
            </mat-card>


        </div>

    </div>
</div>

<app-add-facility [ngClass]="{'open': showAddfacility}"  (CloseAddfacility)=getCloseAddfacility($event)></app-add-facility>

<app-facility-filter [ngClass]="{'open': showmyFilter}"  (CloseAddfilter)=getCloseFilter($event)></app-facility-filter>



<ng-template #facilityrequest>
    <h2 mat-dialog-title>
        <span class="groupIcon" ><mat-icon>message</mat-icon></span>
        Write Message
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography"> 
  
    <mat-form-field>
      <mat-label>Write your message</mat-label>
      <textarea matInput  class="txtarea" placeholder="Write a message..." 
   ></textarea>
    </mat-form-field>
  
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" >Send</button>
  </mat-dialog-actions>
  </ng-template>
  